import React from 'react';
import styled from 'styled-components';
import Box, {BoxProps} from '@material-ui/core/Box';

export const CenterBox = ({ children, ...props }: StackProps) => {
    return (
        <VStack
            {...props}
        >
            {children}
        </VStack>
    );
};

export type StackProps =
    & BoxProps
    & {
    spacing?: string
}

export const VStack = styled(Box)<StackProps>`
  display: flex;
  flex-direction: column;

  ${props => props.spacing ? `
> * {
    margin-bottom: ${props.spacing};
}

> * {
    &:last-child {
        margin-bottom: 0 !important;
    }
}
` : null}
`;

export const HStack = styled(Box)<StackProps>`
  display: flex;
  flex-direction: row;

  ${props => props.spacing ? `
> * {
    margin-right: ${props.spacing};
}

> * {
    &:last-child {
        margin-right: 0 !important;
    }
}
` : null}
`;
